export const socialMedia = [
  { href: 'https://www.instagram.com/waldo_vision/', image: 'instagram' },
  { href: 'https://www.facebook.com/waldovision/', image: 'facebook' },
  { href: 'https://twitter.com/waldo_vision/', image: 'twitter' },
  { href: 'https://m.me/waldovision', image: 'messenger' },
];

export const socialMediaSingle = {
  IG: 'https://www.instagram.com/waldo_vision/',
  FB: 'https://www.facebook.com/waldovision/',
  TWIT: 'https://twitter.com/waldo_vision/',
};
